var _rect, _g, _rect2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "us",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 512,
    height: 512,
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 512,
    height: 64,
    transform: "translate(0 64)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 512,
    height: 64,
    transform: "translate(0 192)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 512,
    height: 64,
    transform: "translate(0 320)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 512,
    height: 64,
    transform: "translate(0 448)",
    fill: "#d80027"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 256,
    height: 275.69,
    fill: "#2e52b2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M51.518,115.318l-5.594,17.211h-18.1l14.643,10.634-5.594,17.212,14.643-10.634,14.637,10.634L60.56,143.163,75.2,132.529h-18.1Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M57.106,194.645l-5.588-17.211-5.594,17.211h-18.1l14.643,10.634L36.875,222.49l14.643-10.633L66.155,222.49,60.56,205.279,75.2,194.645Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M51.518,53.2,45.924,70.414h-18.1L42.469,81.047,36.875,98.259,51.518,87.625,66.155,98.259,60.56,81.047,75.2,70.414h-18.1Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M128,115.318l-5.594,17.211h-18.1l14.643,10.634-5.594,17.212L128,149.741l14.637,10.634-5.6-17.212,14.644-10.634h-18.1Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M133.591,194.645,128,177.434l-5.594,17.211h-18.1l14.643,10.634L113.36,222.49,128,211.857,142.64,222.49l-5.6-17.211,14.644-10.634Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M210.076,194.645l-5.587-17.211-5.6,17.211H180.8l14.643,10.634-5.6,17.211,14.644-10.633,14.636,10.633-5.594-17.211,14.643-10.634Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M204.489,115.318l-5.6,17.211H180.8l14.643,10.634-5.6,17.212,14.644-10.634,14.636,10.634-5.594-17.212,14.643-10.634h-18.1Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M128,53.2l-5.594,17.212h-18.1l14.643,10.633L113.36,98.259,128,87.625,142.64,98.259l-5.6-17.212,14.644-10.633h-18.1Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M204.489,53.2l-5.6,17.212H180.8L195.44,81.047l-5.6,17.212,14.644-10.634,14.636,10.634-5.594-17.212,14.643-10.633h-18.1Z",
    fill: "#f0f0f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.60e5e49d08a5683eb85adcc50e9364f0.svg";
export { ForwardRef as ReactComponent };